import { render, staticRenderFns } from "./FontImport.vue?vue&type=template&id=28cd7930&scoped=true&"
import script from "./FontImport.vue?vue&type=script&lang=js&"
export * from "./FontImport.vue?vue&type=script&lang=js&"
import style0 from "./FontImport.vue?vue&type=style&index=0&id=28cd7930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd7930",
  null
  
)

export default component.exports